<div class="ticket-option">
  <div class="content">
    <span class="tag" *ngIf="banner">{{ banner | i18next }}</span>
    <p class="title">{{ title }}</p>
    <p *ngIf="dailyPrice" class="text text-red">
      {{ 'from_per_day' | i18next: { cost: (dailyPrice | currency) } }}
    </p>
    <p *ngIf="subtitle" class="text">
      {{ subtitle | i18next }}
    </p>
  </div>
  <div class="bottom">
    <p class="price">{{ fullPrice | currency }}</p>
    <nx-ng-buy-single-button
      [count]="count"
      [separateRemoveLink]="true"
      (quantityUpdated)="handleQuantityUpdated($event)"
      [id]="id"
    >
    </nx-ng-buy-single-button>
  </div>
</div>
